<tour-step-template></tour-step-template>
<mat-toolbar>

  <app-sidenav-btn></app-sidenav-btn>
  <span class="spacer"></span>
  <div class="main-navigation">
    <a
      mat-flat-button
      matTooltip="Whats Academate?"
      routerLink="/"
      class="main-navigation--btn"
      [ngClass]="isSmallScreen?'sml':''">
      <div class="logo-btn">
        <img ngSrc="assets/logo.png" alt="logo" width="30" height="30"/>
        @if (!isSmallScreen) {
          <span>Academate</span>
        }
      </div>
    </a>

    @if (isSmallScreen) {
      <a
        mat-icon-button
        routerLink="/project"
        class="settings-btn">
        <mat-icon>account_box</mat-icon>
      </a>
      <a
        mat-icon-button
        routerLink="/documentation"
        class="settings-btn">
        <mat-icon>summarize</mat-icon>
      </a>
      <a
        mat-icon-button
        matTooltip="Explore example projects"
        routerLink="/explore"
        class="settings-btn">
        <mat-icon>explore</mat-icon>
      </a>
    } @else {
      <a
        mat-flat-button
        routerLink="/project"
        class="main-navigation--btn">
        <span>Projects</span>
      </a>
      <a
        mat-flat-button
        matTooltip="Explore example projects"
        routerLink="/explore"
        class="main-navigation--btn">
        <span>Explore</span>
      </a>
    }
  </div>
  <span class="spacer"></span>
  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    class="bug-btn">
    <mat-icon>contact_support</mat-icon>
  </button>

  <button
    matTooltip="Specify the settings for the AI models"
    mat-icon-button
    (click)="openSetting()"
    class="settings-btn bug-btn">
    <mat-icon>settings</mat-icon>
  </button>

</mat-toolbar>
<mat-menu #menu="matMenu">
  <a mat-menu-item
     routerLink="/documentation"
     class="menu--btn">
    <mat-icon>description</mat-icon>
    <span>Documentation</span>
  </a>
  <a
    mat-menu-item
    href="mailto:simon.suewer@uni-hamburg.de"
    class="menu--btn">
    <mat-icon>contact_support</mat-icon>
    <span>Contact the ACADEMATE team</span>
  </a>
  <button
    mat-menu-item
    (click)="openBugReport()"
    class="menu--btn">
    <mat-icon>bug_report</mat-icon>
    <span>Report a bug</span>
  </button>
</mat-menu>
<router-outlet/>
<app-show-message></app-show-message>

